export const KT_FORM_CONTEXT = Symbol('KT_FORM_CONTEXT')
export const KT_FORM_SUBMIT_CONTEXT = Symbol('KT_FORM_SUBMIT_CONTEXT')
